import { render, staticRenderFns } from "./banksTrash.vue?vue&type=template&id=33fd7299&scoped=true"
import script from "./banksTrash.vue?vue&type=script&lang=js"
export * from "./banksTrash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fd7299",
  null
  
)

export default component.exports